<div
  *ngIf="dashboard == null"
  class="row justify-content-center align-items-center loader-wrapper"
>
  <div class="col-auto">
    <div class="loader"></div>
  </div>
</div>

<main *ngIf="dashboard" class="main-content">
  <div class="crm mb-25">
    <div class="container-fluid">
      <div class="row">
        <div class="container">
          <div class="row">
            <div class="col-xxl-12 mb-25">
              <div class="card banner-feature--18 new d-flex gradient-box">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-xl-8">
                      <div class="card-body px-25">
                        <h1
                          class="banner-feature__heading color-dark title-white-style"
                          [innerHTML]="'dashboard.welcome' | translate"
                        >
                          <!-- Hey! <span class="title-style">Welcome to</span> <br> Your Removia Dashboard -->
                        </h1>
                        <p
                          class="banner-feature__para color-dark text-style"
                          [innerHTML]="'dashboard.description' | translate"
                        >
                          <!-- We're working on your behalf to remove your personal
                          data from data brokers across the web. This dashboard
                          gives you a real-time view of the <span class="text-span-style">entire 90-day
                          removal process </span> — including which stage we're in, how
                          long each step takes, and what actions we already
                          taken. Sit back, relax, and let us handle the heavy
                          lifting. -->
                        </p>
                      </div>
                    </div>
                    <div class="col-xl-4">
                      <div class="banner-feature__shape text-center">
                        <img
                          style="padding: 10px; height: 260px"
                          src="assets/images/Illustration.png"
                          alt="img"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div
                class="overview-content overview-content3 pt-20 pb-20 text-center radius-xl"
              >
                <div
                  class="d-inline-flex flex-column align-items-center justify-content-center"
                >
                  <img
                    style="height: 50px"
                    src="assets/images/01.png"
                    alt="img"
                  />
                  <div class="d-flex align-items-start flex-wrap">
                    <div class="mt-3">
                      <p class="mb-1 mb-0 color-gray">
                        <!-- Available Brokers -->
                        {{ "dashboard.stats.availableBrokers" | translate }}
                      </p>

                      <h2>{{ dashboard?.brokers?.all?.length }}</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div
                class="overview-content overview-content3 pt-20 pb-20 text-center radius-xl"
              >
                <div
                  class="d-inline-flex flex-column align-items-center justify-content-center"
                >
                  <img
                    style="height: 50px"
                    src="assets/images/02.png"
                    alt="img"
                  />
                  <div class="d-flex align-items-start flex-wrap">
                    <div class="mt-3">
                      <p class="mb-1 mb-0 color-gray">
                        <!-- Completed -->
                        {{ "dashboard.stats.completed" | translate }}
                      </p>
                      <h2>{{ dashboard?.brokers?.completed?.length }}</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div
                class="overview-content overview-content3 pt-20 pb-20 text-center radius-xl"
              >
                <div
                  class="d-inline-flex flex-column align-items-center justify-content-center"
                >
                  <img
                    style="height: 50px"
                    src="assets/images/03.png"
                    alt="img"
                  />
                  <div class="d-flex align-items-start flex-wrap">
                    <div class="mt-3">
                      <p class="mb-1 mb-0 color-gray">
                        <!-- In progress -->
                        {{ "dashboard.stats.inProgress" | translate }}
                      </p>
                      <h2>{{ dashboard?.brokers?.in_progress?.length }}</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xxl-12 col-lg-12 mb-25">
              <br />
              <div class="progress-box px-25 pt-25 pb-10 bg-success radius-xl">
                <div class="d-flex justify-content-between mb-3">
                  <h6 class="text-white fw-500 fs-16 text-capitalize">
                    <!-- progress -->
                    {{ "dashboard.progress" | translate }}
                  </h6>

                  <span
                    class="progress-percentage text-white fw-500 fs-16 text-capitalize"
                    >{{ progress_percentage }}%</span
                  >
                </div>
                <div class="progress-wrap d-flex align-items-center mb-15">
                  <div class="progress progress-height">
                    <div
                      class="progress-bar bg-white"
                      role="progressbar"
                      [style.width.%]="dashboard?.progress_percentage"
                      aria-valuenow="64"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <br />
              <div class="card border-0 px-25">
                <div class="card-header px-0 border-0">
                  <h6>
                    <!-- Activity Log -->
                    {{ "dashboard.activityLog.title" | translate }}
                  </h6>
                  <div class="card-extra">
                    <ul class="card-tab-links nav-tabs nav" role="tablist">
                      <li>
                        <a
                          class="active"
                          href="#t_selling-today"
                          data-bs-toggle="tab"
                          id="t_selling-today-tab"
                          role="tab"
                          aria-selected="true"
                        >
                          <!-- All -->
                          {{ "dashboard.activityLog.tabs.all" | translate }}
                        </a>
                      </li>
                      <li>
                        <a
                          href="#t_selling-week"
                          data-bs-toggle="tab"
                          id="t_selling-week-tab"
                          role="tab"
                          aria-selected="true"
                        >
                          <!-- Completed -->
                          {{
                            "dashboard.activityLog.tabs.completed" | translate
                          }}
                        </a>
                      </li>
                      <li>
                        <a
                          href="#t_selling-month"
                          data-bs-toggle="tab"
                          id="t_selling-month-tab"
                          role="tab"
                          aria-selected="true"
                        >
                          <!-- In progress -->
                          {{
                            "dashboard.activityLog.tabs.inProgress" | translate
                          }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="card-body p-0">
                  <div class="tab-content">
                    <div
                      class="tab-pane fade active show"
                      id="t_selling-today"
                      role="tabpanel"
                      aria-labelledby="t_selling-today-tab"
                    >
                      <div class="selling-table-wrap">
                        <div class="table-responsive">
                          <table class="table table--default table-borderless">
                            <thead>
                              <tr>
                                <th>
                                  <!-- Broker name -->
                                  {{
                                    "dashboard.activityLog.table.brokerName"
                                      | translate
                                  }}
                                </th>
                                <th>
                                  <!-- Request sent on -->
                                  {{
                                    "dashboard.activityLog.table.requestSentOn"
                                      | translate
                                  }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let broker of all_brokers">
                                <td>
                                  <div
                                    class="selling-product-img d-flex align-items-center"
                                  >
                                    <img
                                      class="radius-xs img-fluid"
                                      [src]="broker.logo"
                                      alt="{{ broker.name }} logo"
                                      (error)="handleImageError($event)"
                                    />
                                    <span>{{ broker.name }}</span>
                                  </div>
                                </td>
                                <td *ngIf="broker.last_contact">
                                  {{ broker.last_contact }}
                                </td>
                                <td *ngIf="!broker.last_contact">
                                  <!-- Scheduled For Sending -->
                                  {{
                                    "dashboard.activityLog.table.scheduled"
                                      | translate
                                  }}
                                </td>
                              </tr>
                              <tr *ngIf="all_brokers.length === 0">
                                <td colspan="8" class="text-center">
                                  <!-- No brokers found -->
                                  {{
                                    "dashboard.activityLog.table.noBrokers"
                                      | translate
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="t_selling-week"
                      role="tabpanel"
                      aria-labelledby="t_selling-week-tab"
                    >
                      <div class="selling-table-wrap">
                        <div class="table-responsive">
                          <table class="table table--default table-borderless">
                            <thead>
                              <tr>
                                <th>
                                  <!-- Broker name -->
                                  {{
                                    "dashboard.activityLog.table.brokerName"
                                      | translate
                                  }}
                                </th>
                                <th>
                                  <!-- Request sent on -->
                                  {{
                                    "dashboard.activityLog.table.requestSentOn"
                                      | translate
                                  }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let broker of completed_brokers">
                                <td>
                                  <div
                                    class="selling-product-img d-flex align-items-center"
                                  >
                                    <img
                                      class="radius-xs img-fluid order-bg-opacity-primary"
                                      [src]="broker.logo"
                                      alt="{{ broker.name }} logo"
                                      (error)="handleImageError($event)"
                                    />
                                    <span>{{ broker.name }}</span>
                                  </div>
                                </td>
                                <td>{{ broker.last_contact }}</td>
                              </tr>
                              <tr *ngIf="completed_brokers.length === 0">
                                <td colspan="8" class="text-center">
                                  <!-- No completed brokers found -->
                                  {{
                                    "dashboard.activityLog.table.noCompleted"
                                      | translate
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="t_selling-month"
                      role="tabpanel"
                      aria-labelledby="t_selling-month-tab"
                    >
                      <div class="selling-table-wrap">
                        <div class="table-responsive">
                          <table class="table table--default table-borderless">
                            <thead>
                              <tr>
                                <th>
                                  <!-- Broker name -->
                                  {{
                                    "dashboard.activityLog.table.brokerName"
                                      | translate
                                  }}
                                </th>
                                <th>
                                  <!-- Request sent on -->
                                  {{
                                    "dashboard.activityLog.table.requestSentOn"
                                      | translate
                                  }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let broker of in_progress_brokers">
                                <td>
                                  <div
                                    class="selling-product-img d-flex align-items-center"
                                  >
                                    <img
                                      class="radius-xs img-fluid order-bg-opacity-primary"
                                      [src]="broker.logo"
                                      alt="{{ broker.name }} logo"
                                      (error)="handleImageError($event)"
                                    />
                                    <span>{{ broker.name }}</span>
                                  </div>
                                </td>
                                <td>
                                  <!-- Scheduled For Sending -->
                                  {{
                                    "dashboard.activityLog.table.scheduled"
                                      | translate
                                  }}
                                </td>
                              </tr>
                              <tr *ngIf="in_progress_brokers.length === 0">
                                <td colspan="8" class="text-center">
                                  <!-- No brokers in progress found -->
                                  {{
                                    "dashboard.activityLog.table.noInProgress"
                                      | translate
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <br />
              <div class="card border-0 card-timeline h-100">
                <div class="card-header border-0">
                  <h6>
                    <!-- Timeline -->
                    {{ "dashboard.timeline.title" | translate }}
                  </h6>
                </div>
                <div class="card-body pb-15 mt-n15 pt-0">
                  <div class="card-timeline-body">
                    <ul>
                      <li *ngFor="let timeline of timelines">
                        <div class="card-timeline-body__left">
                          <div class="card-timeline-body__title">
                            <span class="timeline-line"></span>
                            <span
                              class="badge-dot badge-dot--big"
                              [style.backgroundColor]="timeline.color"
                            ></span>
                            <p>
                              {{ get_translated_timeline(timeline.text) }}
                            </p>
                          </div>
                        </div>
                        <div class="card-timeline-body__right">
                          <div class="card-timeline-body__time">
                            <span>{{
                              getFormattedDate(timeline.completion_date)
                            }}</span>
                            <span style="padding: 10px">
                              <i
                                *ngIf="timeline.is_completed"
                                class="fa fa-check"
                                aria-hidden="true"
                              ></i>
                              <i
                                *ngIf="!timeline.is_completed"
                                class="fas fa-spinner"
                              ></i>
                            </span>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div *ngIf="timelines.length === 0">
                      <p colspan="8" class="text-center">
                        <!-- No timelines found -->
                        {{ "dashboard.timeline.noTimelines" | translate }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container-fluid">
              <div class="social-dash-wrap">
                <div class="row">
                  <div
                    class="col-lg-12 mb-xxl-45 mb-md-50 mb-30"
                    style="padding-top: 50px"
                  >
                    <div class="card" style="background-color: #e3ecff">
                      <div
                        class="d-flex align-items-center flex-sm-nowrap flex-wrap text-sm-start text-center"
                      >
                        <div
                          class="card-body"
                          style="padding-top: 40px; padding-bottom: 40px"
                        >
                          <h2 class="banner-feature__heading text-center">
                            <!-- BLOG -->
                            {{ "dashboard.blog.title" | translate }}
                          </h2>
                          <p
                            class="banner-feature__para text-center"
                            [innerHTML]="
                              'dashboard.blog.description' | translate
                            "
                          >
                            <!-- Explore in-depth insights on online privacy, data security, and how to protect your personal information.
                            <br>
                            Our blog empowers you to stay safe in an increasingly connected world. -->
                          </p>
                          <div class="text-center">
                            <a
                              href="/blog"
                              target="_blank"
                              class="d-inline-block"
                            >
                              <button
                                style="
                                  background-color: #8a7bff;
                                  border-color: #ffffff33;
                                "
                                class="btn btn-primary"
                                type="button"
                              >
                                <!-- Learn More -->
                                {{ "dashboard.blog.button" | translate }}
                              </button>
                            </a>
                          </div>
                        </div>
                        <div class="banner-feature__shape">
                          <img
                            style="height: 200px; padding-right: 50px"
                            src="assets/images/logo_s.png"
                            alt="img"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
